import request from '@/common/request'
import { EventoDeWebhookDisponivel, FormWebhook, Webhook } from '@/models'

const PATH = '/webhooks'

export const listar = async (): Promise<Webhook[]> =>
	await request.get(`${PATH}`)

export const get = async (id: string): Promise<Webhook> =>
	await request.get(`${PATH}/${id}`)

export const create = async (data: FormWebhook): Promise<Webhook> =>
	await request.post(`${PATH}`, data)

export const update = async (data: FormWebhook): Promise<Webhook> =>
	await request.put(`${PATH}/${data.id}`, data)

export const remove = async (id: string): Promise<void> =>
	request.delete(`${PATH}/${id}`)

export const testar = async (id: string): Promise<void> =>
	request.post(`${PATH}/${id}/testar`)

export const listarEventosDisponiveis = async (): Promise<EventoDeWebhookDisponivel[]> =>
	await request.get(`${PATH}/eventos`)
